/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createShoppingCartFromDiscriminatorValue, serializeShoppingCart, serializeUpdateLineRequest, type ErrorResponse, type InternalErrorResponse, type ShoppingCart, type UpdateLineRequest } from '../../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/carts/{cart-id}/{shoppingCartId}/lines/{lineId}
 */
export interface WithLineItemRequestBuilder extends BaseRequestBuilder<WithLineItemRequestBuilder> {
    /**
     * Delete one cart line, named by the lineId every line carries. Use this instead of DELETE .../items/{sku} when a SKU is on more than one line. If this is the last line, the cart is deleted. Idempotent: deleting a line that is no longer in the cart succeeds without changing it.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {ErrorResponse} error when the service returns a 409 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Change the quantity of one cart line, named by the lineId every line carries. Use this instead of PUT .../items/{sku} when a SKU is on more than one line (a product sold as separate lines). A quantity of 0 removes the line, and succeeds even if the line is already gone.
     * @param body A request to change the quantity of one cart line, named by its id (CU-86bcpta0t): the onlyway to reach a line when its SKU is on several lines of the cart.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ShoppingCart>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {ErrorResponse} error when the service returns a 409 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: UpdateLineRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ShoppingCart | undefined>;
    /**
     * Delete one cart line, named by the lineId every line carries. Use this instead of DELETE .../items/{sku} when a SKU is on more than one line. If this is the last line, the cart is deleted. Idempotent: deleting a line that is no longer in the cart succeeds without changing it.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Change the quantity of one cart line, named by the lineId every line carries. Use this instead of PUT .../items/{sku} when a SKU is on more than one line (a product sold as separate lines). A quantity of 0 removes the line, and succeeds even if the line is already gone.
     * @param body A request to change the quantity of one cart line, named by its id (CU-86bcpta0t): the onlyway to reach a line when its SKU is on several lines of the cart.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateLineRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithLineItemRequestBuilderUriTemplate = "{+baseurl}/api/carts/{cart%2Did}/{shoppingCartId}/lines/{lineId}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithLineItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithLineItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
    put: {
        uriTemplate: WithLineItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createShoppingCartFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateLineRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
